<template>
  <div class="books">
    <div class="content_banner">
      <img src="../assets/img/banner/banner_server.jpg" alt="">
    </div>
    <div class="container_wrap search_wrap">
        <el-table :data="list" style="width: 100%">
        <el-table-column label="序号" type="index" width="50" align="center">
        </el-table-column>
        <el-table-column label="编号" align="center">
          <template slot-scope="scope">
            {{ scope.row.no }}
          </template>
        </el-table-column>
        <el-table-column label="名称" align="center">
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="标准号" align="center">
          <template slot-scope="scope">
            {{ scope.row.typeNo }}
          </template>
        </el-table-column>
        <el-table-column label="标准类型" align="center">
          <template slot-scope="scope">
            {{ scope.row.type }}
          </template>
        </el-table-column>
        <el-table-column label="专业" align="center">
          <template slot-scope="scope">
            {{ scope.row.profession }}
          </template>
        </el-table-column>
        <el-table-column label="发布时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.sendTime==""? '-' : dayjs(scope.row.sendTime).format("YYYY-MM-DD") }}
          </template>
        </el-table-column>
        <el-table-column label="实施时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.makeTime==""? '-' : dayjs(scope.row.makeTime).format("YYYY-MM-DD") }}
          </template>
        </el-table-column>
        <el-table-column label="文件下载" align="center">
          <template slot-scope="scope">
            <!-- <a :href="baseURL+'/'+scope.row.file" :download="scope.row.name" target="_blank">点击下载</a> -->
            <a :href="baseURL+'/'+scope.row.file" :download="scope.row.name" target="_blank"><el-button type="primary" size="mini">点击下载</el-button></a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'books',
  data(){
    return{
      list: [],
      baseURL: this.apiUrl
    }
  },
  mounted: function(){
    var _this = this;
    _this.getData();
  },
  methods: {
    async getData(){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/books/getBooks');
      if(data.code == 200){
        _this.list = data.data
      }
    }
  }
}
</script>